import { render, staticRenderFns } from "./BonusChargeCreate.vue?vue&type=template&id=55fc3424&scoped=true"
import script from "./BonusChargeCreate.vue?vue&type=script&lang=js"
export * from "./BonusChargeCreate.vue?vue&type=script&lang=js"
import style0 from "./BonusChargeCreate.vue?vue&type=style&index=0&id=55fc3424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc3424",
  null
  
)

export default component.exports